export function ID() {
  return '_' + Math.random().toString(36).substr(2, 9);
}

export function precisionRound(number, precision) {
  var factor = Math.pow(10, precision);
  return Math.round(number * factor) / factor;
}



// WEBPACK FOOTER //
// ./src/Utils.js